import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Home from './pages/Home';
import Redirect from './pages/Redirect';
import Loader from './components/Loader';

function App() {
  const [loading, setLoading] = useState(true);

  // Store all short links here
  // Format: shortCode: "destination_url"

  // Add dummy text for testing purposes ---- delete later

  const links = {
    myfinancialuk: "https://www.deere.uk/myfinancial",
    github: "https://www.github.com",
    youtube: "https://www.youtube.com",
    deere: "https://www.deere.com",
    t7ausif: "https://www.youtube.com",
  };

  const handleLoaderComplete = () => {
    setLoading(false);
  };

  if (loading) {
    return <Loader onComplete={handleLoaderComplete} />;
  }

  return (
    <Router>
      <Routes>
        {/* Home route - shows John Deere logo */}
        <Route path="/" element={<Home />} />

        {/* Redirect route - handles all short codes */}
        <Route path="/:shortCode" element={<Redirect links={links} />} />

        {/* Catch all - redirect to home */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;
